const $ = (selector, parent = document) => parent.querySelector(selector);
const $$ = (selector, parent = document) => parent.querySelectorAll(selector);

const modals = $$(".case-study dialog");
modals.forEach(modal => {
  // Observes the modal header, which should have `top: -1px`, and toggles
  // the `stuck` class when it hits the top of the modal.
  new IntersectionObserver(
    ([e]) => e.target.classList.toggle("stuck", e.intersectionRatio < 1),
    {
      root: modal,
      threshold: [1]
    }
  ).observe($(`:scope > header`, modal));
});
